module.exports = __webpack_public_path__ + "img/empty.a9e4b3b4.png";